import { render, staticRenderFns } from "./FullDesign.vue?vue&type=template&id=ac3fbabc"
import script from "./FullDesign.vue?vue&type=script&lang=ts"
export * from "./FullDesign.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./FullDesign.vue?vue&type=style&index=0&id=ac3fbabc&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports